<template>
  <div class="active-challenge-summary">
    <riseup-header/>
    <div class="top">
      <div class="header">
        <div class="headline"> היי {{ participantName }},</div>
        <div class="description">{{ description }}</div>
      </div>
      <div class="background-wrapper">
        <div class="hidden-background">
          <div class="white-background"/>
          <img :src="require('@/assets/challenge/RoundBottomWhite.svg')" class="ellipse">
        </div>
      </div>
      <div class="card-wrapper">
        <challenge-progress-card :headline="'הוצאת באתגר'" :challenge-goal="challengeAmount" :spent="participantSpent"
                                 :can-add-expense="false" :add-expense="() => {}"/>
      </div>
    </div>
    <div class="challenge-summary">
      <div class="summary-header">{{ summaryHeader }}</div>
      <div class="summary-description">{{ summaryDescription }}</div>
    </div>
    <div class="join-riseup" v-if="!isCustomer">
      <riseup-button class="join-button" title="הצטרפות לרייזאפ" :action="join" variant="secondary"/>
    </div>
  </div>
</template>

<script>

import BaseUI from 'base-ui';
import { mapActions, mapState, mapGetters } from 'vuex';
import router from '@/router';
import Segment from '@/Segment';
import ChallengeProgressCard
  from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/ChallengeProgressCard';
import RiseupHeader from '@/base-components/app-header/RiseupHeader';
import {
  EATING_OUT_CHALLENGE_PROTOTYPE_V1,
} from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/constants';

export default {
  name: 'ActiveChallengeSummary',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    ChallengeProgressCard,
    RiseupHeader,
  },
  computed: {
    ...mapState('accountabilityChallenge', ['activeChallenge', 'activeParticipant', 'ownerParticipantId']),
    ...mapGetters('accountabilityChallenge', ['participantName', 'participantSpent', 'participantId',
      'challengeAmount', 'leftToSpend', 'isCustomer']),
    challengeSucceeded() {
      return this.leftToSpend >= 0;
    },
    headline() {
      return this.challengeSucceeded ? `כל הכבוד ${this.participantName}` : `היי ${this.participantName}`;
    },
    description() {
      return this.challengeSucceeded
        ? 'הצלחת לעמוד ביעד האתגר של הקבוצה!'
        : 'נראה שלא עמדת באתגר הפעם, אבל רק להשתתף באתגר זה צעד ראשון בדרך להצלחה.';
    },
    summaryHeader() {
      return this.challengeSucceeded ? `נשארו לך ₪${this.leftToSpend} לבזבוזים!` : '';
    },
    summaryDescription() {
      if (this.isCustomer) {
        return '';
      }
      return this.challengeSucceeded
        ? 'רוצה לגלות את ההוצאה האמיתית שלך על אוכל בחוץ? אפשר להצטרף לרייזאפ ולגלות - חודש התנסות חינם עלינו!'
        : 'להצליח לעמוד ביעדים שלך לבד יכול להיות קשה, הצטרפות לרייזאפ, גם אם רק לתקופת הנסיון בחינם יכולה לעשות שינוי משמעותי במצב הכלכלי שלך';
    },
  },
  created() {
    Segment.trackUserGot('EatingOutChallengeSummaryEntered', {
      participantId: this.participantId,
      isCustomer: this.isCustomer,
      challengeId: this.ownerParticipantId,
      shareName: EATING_OUT_CHALLENGE_PROTOTYPE_V1,
    });
  },
  methods: {
    ...mapActions('modalRootStore', ['closeModal']),
    join() {
      router.push({ path: '/signup' });
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../scss/mixins';
.active-challenge-summary {
  @include white-page-frame;
  height: 100%;
  background-color: $riseup-blue;
  .top {
    width: 100%;
    .header {
      @include responsive-padding;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 24px;
      background-color: $riseup_white;
      color: $riseup_blue;
      text-align: center;
      .headline {
        margin-top: 15px;
        font-weight: bold;
        font-size: 24px;
      }
      .description {
        margin-top: 16px;
        height: 75px;
        font-size: 18px;
        line-height: 140%;
        white-space: pre-line;
      }
    }
    .background-wrapper {
      position: relative;
      .hidden-background {
        position: absolute;
        top: 0;
        background-color: $riseup-blue;
        .white-background {
          height: 80px;
          background-color: $riseup-white;
        }
        .ellipse {
          width: 100%;
        }
      }
    }
    .card-wrapper {
      @include responsive-padding;
    }
  }

  .challenge-summary {
    @include responsive-padding;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: $riseup_white;
    font-family: SimplerPro;
    font-size: 18px;
    line-height: 140%;
    .summary-header {
      margin-top: 24px;
      font-weight: bold;
    }
    .summary-description {
      margin-top: 24px;
      height: 100px;
    }
  }
  .join-riseup {
    margin: 24px 0;
    width: 100%;
    @include responsive-padding;
    .join-button {
      width: 100%;
      height: 60px;
    }
  }
}

</style>
